/**
 * Defines an interface that allows children of a container to be traversed.  All layout containers
 * should mix this in and supply their own method implementations.
 *
 * @module MW/layout/Traversable
 * @copyright Copyright 2015 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare"
], function (declare) {
    return declare([], {

        /**
         * Makes the specified child visible.  This may involve expanding if it is collapsed, selecting the associated
         * tab if it is not showing, etc.
         *
         * @param widget {_Widget} the child to reveal
         * @abstract
         * @instance
         */
        revealChild: function (widget) {},

        /**
         * @param widget {_Widget} the reference child (may be null)
         * @param showing {boolean} if true then return a child that is already showing, e.g. not collapsed or hidden behind a tab.
         * @returns {_Widget} the next child in the traversal order (may be null)
         * @abstract
         * @instance
         */
        nextChild: function (widget, showing) {return null;} ,

        /**
         * @param widget {_Widget} the reference child (may be null)
         * @param showing {boolean} if true then return a child that is already showing, e.g. not collapsed or hidden behind a tab.
         * @returns {_Widget} the previous child in the traversal order (may be null)
         * @abstract
         * @instance
         */
        previousChild: function (widget, showing) {return null;}
    });
});